<template>
	<div class="popup">

        <div class="popup-header">

              {{planningrule_by_id(code.rule_id).rulename}}
            <div v-if="code.id == 0" class="popup-close" @click="$emit('close')">
                <font-awesome-icon icon="times" />
            </div>
            <div v-else class="popup-close" @click="save_and_close">
                <font-awesome-icon icon="times" />
            </div>
        </div>
        <div class="popup-body">
            <b-container>
                <form class="form" v-on:submit='save_and_close'>
                    <!-- branche name -->
                    <div class="form-row">
                        <div class="col-3">
                            <label for="">Regel type</label>
                        </div>
                        <div class="col">
                          <select v-model="code.type_id" class="form-control">
                            <option v-for="(ruletype,idx) in planningruletypes" :key="idx" v-bind:value="ruletype.id">
                            {{ ruletype.title}}
                        </option>
                          </select>
                        </div>
                    </div>
                    <div class="form-row" v-if="code.type_id">
                        <div class="col-3">
                            <label for=""></label>
                        </div>
                        <div class="col">
                          {{ planningruletype_by_id(code.type_id).description }}
                        </div>
                      </div>
                </form>
            </b-container>
        </div>
        <div class="popup-footer">
            <div v-if="code.id == 0" class="btn btn-primary" @click="my_add_code();">{{ addcodeText() }}</div>
            <div v-else @click="save_and_close" class="btn btn-primary">{{ $t("buttons.saveandclose") }}</div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    name: 'planingrule-modal',
    data() {
        return {
            new_code:{id:0, type_id:null, rule_id:null, contribution:0.5, rangevalue:40,required:1} 
            // nationalities:[]

        }
    },
    props: {
        id: Number,
        rule_id:Number
    },
    async mounted() {
       this.new_code.rule_id= this.rule_id
       console.log(">>>>>>>>>>", this.new_code)

    },
    computed: {
      ...mapState([
      'planningrules',
      'planningruletypes'
    ]),
    ...mapGetters([
    'planningrule_by_id',
    'planningruletype_by_id',
    ]),
        code() {
            return this.id > 0 ? this.planningrule_by_id(this.id) : this.new_code
        },
        checkcode(){
          
                return true
            // }
            // let found=false;
            // if(this.code.code!=undefined){
            //     for(var i=0;i<this.planningrules.length;i++){
            //         if(this.code.rulename.toLowerCase()==this.planningrules[i].rulename.toLowerCase()){
            //             found = true;
            //             break;
            //         }
            //     }
            // }
            // return !found &&this.code.rulename!=undefined&& this.code.rulename.length>=2
        }        
    },
    methods: {
        addcodeText(){
            if (this.checkcode){
                return this.$i18n.t("buttons.add") 
            } else { 
                return this.$i18n.t("buttons.invalid") 
            }
        },
        save_and_close(e) {
            e.preventDefault() // it prevent from page reload
            if(this.code.id==0){
                this.my_add_code()
            }else{
                this.save_planningrule(this.code.id)
                this.$emit('close')
            }            
        },
        ...mapActions([
            'save_planningrule',
            'add_planningrule'
        ]),
        my_add_code(){
            if(this.checkcode){
              axios.put("/api/set_planningrule/" + this.code.id, this.code).then(() => {
                // Vue.set(planningrule, 'id', response.data.id)
                this.$store.dispatch('get_planningrules')
              })                
      
                this.$emit('close')
            }
        },

    focusInput() {
      this.$refs.deffield.focus();
    }        

    }
}
</script>